// 短信登录
import React, { useState } from 'react';
import { Input, Button, message } from 'antd';
import intl from 'react-intl-universal';

import IconFont from '@/components/IconFont';
import useCountdown from '@/hooks/useCountDown';

import styles from './index.module.scss';

const CodeButton = (props) => {
  const [isSubmit, setSubmitStatus] = useState(false);
  const [timeLeft, startCountDown] = useCountdown({});
  const { onSendCode } = props;

  const isPending = timeLeft > 0;

  const handleTimerClick = () => {
    try {
      if (document && document.activeElement) {
        (document.activeElement as HTMLInputElement).blur();
      }
    } catch (_) {
      //
    }
    if (isSubmit) return;
    setSubmitStatus(true);
    onSendCode().then(
      (res) => {
        startCountDown(res.data || 60); // 默认六十秒
        message.success(intl.get('login_sms_msg5'));
        setSubmitStatus(false);
      },
      () => {
        setSubmitStatus(false);
      },
    );
  };

  if (isPending) {
    return (
      <Button className={styles.codeSendButton} disabled>
        {intl.get('login_sms_btn1', { timeLeft })}
      </Button>
    );
  }

  return (
    <Button type="primary" className={styles.codeSendButton} onClick={handleTimerClick}>
      {intl.get('login_sms_btn2')}
    </Button>
  );
};

const Index = (props) => {
  const { value, onChange, onSendCode } = props;

  return (
    <div className={styles.codeInputWrapper}>
      <Input
        prefix={<IconFont type="icon-mima" />}
        allowClear
        placeholder={intl.get('login_sms_ph2')}
        value={value}
        onChange={onChange}
        maxLength={4}
      />
      <CodeButton onSendCode={onSendCode} />
    </div>
  );
};

export default Index;
